import { ComponentProps } from 'react';

export function CarTwoToneMd({ ...props }: ComponentProps<'svg'>) {
    return (
        <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
            <path
                d='M14.5033 2.5C16.529 2.5 18.3092 3.92483 18.6095 5.92744L19.1452 9.5L19.7105 9.5C21.1956 9.5 22.4572 10.5865 22.6774 12.0551L22.955 13.9068C23.2092 15.6015 22.3661 17.1733 21.0006 17.9644L21.0007 18C21.0007 19.933 19.4337 21.5 17.5007 21.5C15.7373 21.5 14.2784 20.1958 14.0361 18.4994C14.0244 18.4998 14.0126 18.5 14.0007 18.5H10.0007C9.9889 18.5 9.97711 18.4998 9.96537 18.4994C9.72303 20.1958 8.26418 21.5 6.50073 21.5C4.64357 21.5 3.12424 20.0535 3.0079 18.2257C2.11343 17.8139 1.44894 16.9733 1.29473 15.9449L1.04703 14.293C0.675287 11.814 2.5549 9.58015 5.04046 9.50211L6.56185 6.12015C7.5588 3.90399 9.82582 2.5 12.2978 2.5H14.5033Z'
                fill='#23B4FF'
            />
            <path
                d='M11.0007 9.5H5.04141L5.94112 7.5H11.0007V2.63063C11.4225 2.54466 11.8569 2.5 12.2978 2.5H13.0007V7.5C13.0007 8.60457 12.1053 9.5 11.0007 9.5Z'
                fill='currentColor'
            />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M17.5007 21.5C15.5677 21.5 14.0007 19.933 14.0007 18C14.0007 16.067 15.5677 14.5 17.5007 14.5C19.4337 14.5 21.0007 16.067 21.0007 18C21.0007 19.933 19.4337 21.5 17.5007 21.5ZM17.5007 19.5C16.6723 19.5 16.0007 18.8284 16.0007 18C16.0007 17.1716 16.6723 16.5 17.5007 16.5C18.3292 16.5 19.0007 17.1716 19.0007 18C19.0007 18.8284 18.3292 19.5 17.5007 19.5Z'
                fill='currentColor'
            />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M6.50073 21.5C4.56774 21.5 3.00073 19.933 3.00073 18C3.00073 16.067 4.56774 14.5 6.50073 14.5C8.43373 14.5 10.0007 16.067 10.0007 18C10.0007 19.933 8.43373 21.5 6.50073 21.5ZM6.50073 19.5C5.67231 19.5 5.00073 18.8284 5.00073 18C5.00073 17.1716 5.67231 16.5 6.50073 16.5C7.32916 16.5 8.00073 17.1716 8.00073 18C8.00073 18.8284 7.32916 19.5 6.50073 19.5Z'
                fill='currentColor'
            />
        </svg>
    );
}
